import { ReactNode } from "react";
import Buttons, { Btn } from "../Buttons/Buttons";

export default function PopupFooter({
    hasOutline,
    buttons,
    predButtons
}: {
    hasOutline: boolean,
    buttons: Btn[],
    predButtons?: ReactNode[],
}) {
    return (
        <div className={`w-full flex ${predButtons !== undefined ? 'justify-between' : 'justify-end'} items-center gap-4 p-6 border-light-outline ${hasOutline ? 'border-t' : 'border-none'}`}>
            {predButtons !== undefined && (
                <div className="flex gap-4 justify-start items-center">
                    {predButtons.map((btn, i) => (
                        <>{btn}</>
                    ))}
                </div>
            )}

            <div className="flex gap-4 justify-end items-center">
                {buttons.map((btn, i) => (
                    <Buttons 
                        key={i}
                        id={btn.id}
                        type={btn.type}
                        styling={btn.styling}
                        label={btn.label}
                        startingAdornment={btn.startingAdornment}
                        endingAdornment={btn.endingAdornment}
                        action={btn.action}
                        isLoading={btn.isLoading}
                    />
                ))}
            </div>
        </div>
    )
}